import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, Pagination } from "antd";
import viVN from 'antd/locale/vi_VN';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { ICustomer, ListField } from "../../../../api/Customer_V2/customerApi_V2";
import { ICustomerFields } from "../../../../api/salesSericeCustomer/salesSericeCustomerApi";
import { CustomLoadingOverlayTable, dataPagination, getWidthFromHeader, renderValueAsJSX } from "../../../../until";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import ".././stylestabs.scss";
import FilterHeader from "./Components/FilterHeader";
import { formatNumber } from "../../../../services/mixin";
import { IPagination } from "../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import { generateColumnsFromCodesAgGridReactRecordCar } from "./ContactInformation";
import { NodataTable } from "../../../../components/NoDataTable";
import { NO_VIEW } from "../../../../services/data";



export type WarrantyInformationHandle = {
  getFilters: () => {
    dataFilterActive: FlattenedField[]; dataFilterNoActive: ListField[];
  };
  setFilters: (active: FlattenedField[], noActive: ListField[]) => void; // 👈 thêm hàm này
};

interface Prop {
  loadingTableDetail: boolean

  dataFieldsActive: FlattenedField[]
  data: ICustomer[]
  pagination: IPagination

  onPaginationChange: (page: number, pageSize: number) => void
}

const WarrantyInformation = forwardRef<WarrantyInformationHandle, Prop>(
  (
    {
      loadingTableDetail, dataFieldsActive, data, pagination,
      onPaginationChange

    }, ref
  ) => {
    // useImperativeHandle(ref, () => ({
    //   getFilters: () => ({
    //     dataFilterActive,
    //     dataFilterNoActive,
    //   }),
    //   setFilters: (dataFilterActive, dataFilterNoActive) => {
    //     setDataFilterActive(dataFilterActive);
    //     setDataFilterNoActive(dataFilterNoActive);
    //   },
    // }));


    const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);

    //#region Cấu hình bảng
    const memoizedColumnDefs = useMemo(() => {
      return generateColumnsFromCodesAgGridReactRecordCar(
        columnsMapShow, dataFieldsActive, undefined,
        () => { }
      );
    }, [columnsMapShow, dataFieldsActive]);

    const tableData = useMemo(() => {
      return data.map((item) => {
        const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
          acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;
          return acc;
        }, {});

        return {
          ...item,
          key: item.id.toString(),
          ...fieldValues
        };
      });
    }, [data]);


    useEffect(() => {
      const codes = dataFieldsActive.map((f) => f.fieldCode);
      setColumnsMapShow(codes);
    }, [dataFieldsActive]);

    //#endregion



    return (
      <>

        <div className={`order-history-card__body custom-page-css flex flex-1 flex-col justify-between`}>
          <div className="ag-theme-alpine custom-table-ag custom-css-table"
            style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
          >
            <AgGridReact
              className="my-auto-height-grid"
              getRowStyle={(params: any) => ({
                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              rowData={tableData}
              columnDefs={memoizedColumnDefs}
              rowHeight={55}
              overlayNoRowsTemplate={NodataTable}

              loading={loadingTableDetail}
              loadingOverlayComponent={CustomLoadingOverlayTable}
              // onSelectionChanged={onSelectionChanged}
              // Performance optimizations
              suppressColumnVirtualisation={true} // Giữ tất cả columns trong DOM
              suppressRowVirtualisation={false} // Giữ row virtualization
              enableCellTextSelection={true}
              ensureDomOrder={true}
              debounceVerticalScrollbar={true}
              suppressScrollOnNewData={true}
              suppressDragLeaveHidesColumns={true}

              // Thêm các props sau để cải thiện scroll
              rowBuffer={20}
              maxBlocksInCache={10}
              infiniteInitialRowCount={1000}
              onGridReady={(params) => {
                params.api.sizeColumnsToFit();
              }}
            />
          </div>
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={() =>
                  `Tổng cộng ${dataPagination(
                    pagination.total,
                    pagination.pageSize,
                    pagination.current
                  ).totalPage} trang`
                }
                className="rs-pagination"
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>
        </div>
      </>
    );
  })
export default WarrantyInformation;
